import { DynamicField } from './dynamic-field.model';

export class DynamicFormDateTime extends DynamicField {
  override controlType = 'date';
  override type: string;

  constructor(options: { [x in string]: any } = {}) {
    super(options);
    this.type = options['type'] || '';
    this.config.format = options['config']?.format || 'DD/MM/YYYY';
  }
}
